/* eslint-disable no-useless-constructor */
class Result<T = any, U = any> {
  constructor(public readonly value: T, public readonly error: U) {}

  static Error<U = any>(error: U): Result<null, U> {
    return new Result(null, error)
  }

  static Done<T = any>(value: T): Result<T, null> {
    return new Result(value, null)
  }

  isError(): this is Result<null, U> {
    return !this.value
  }

  isDone(): this is Result<T, null> {
    return !!this.value
  }
}

export default Result
